import { render, staticRenderFns } from "./FiltroFuneraria.vue?vue&type=template&id=64edae24&scoped=true"
import script from "./FiltroFuneraria.vue?vue&type=script&lang=js"
export * from "./FiltroFuneraria.vue?vue&type=script&lang=js"
import style0 from "./FiltroFuneraria.vue?vue&type=style&index=0&id=64edae24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64edae24",
  null
  
)

export default component.exports